/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import { defineMessages } from 'react-intl'

export const UNKNOWN_ENTITY_NAME = 'Institution inconnue'

export const messages = defineMessages({
  CREATE_CONSUMER: {
    id: 'consumer.CREATE_CONSUMER',
    defaultMessage: 'CREATE_CONSUMER'
  },
  CONSUMER_ACTION_CANCEL: {
    id: 'consumer.CONSUMER_ACTION_CANCEL',
    defaultMessage: 'CONSUMER_ACTION_CANCEL'
  },
  CONSUMER_ACTION_SUBMIT: {
    id: 'consumer.CONSUMER_ACTION_SUBMIT',
    defaultMessage: 'CONSUMER_ACTION_SUBMIT'
  },
  FIRST_NAME_LABEL: {
    id: 'consumer.FIRST_NAME_LABEL',
    defaultMessage: 'FIRST_NAME_LABEL'
  },
  LAST_NAME_LABEL: {
    id: 'consumer.LAST_NAME_LABEL',
    defaultMessage: 'LAST_NAME_LABEL'
  },
  ENTITY_LABEL: {
    id: 'consumer.ENTITY_LABEL',
    defaultMessage: 'ENTITY_LABEL'
  },
  PHONE_NUMBER_LABEL: {
    id: 'consumer.PHONE_NUMBER_LABEL',
    defaultMessage: 'PHONE_NUMBER_LABEL'
  },
  EMAIL_LABEL: {
    id: 'consumer.EMAIL_LABEL',
    defaultMessage: 'EMAIL_LABEL'
  },
  REMARK_LABEL: {
    id: 'consumer.REMARK_LABEL',
    defaultMessage: 'REMARK_LABEL'
  },
  FUNCTION_LABEL: {
    id: 'consumer.FUNCTION_LABEL',
    defaultMessage: 'FUNCTION_LABEL'
  },
  MANDATORY_FIELD: {
    id: 'consumer.MANDATORY_FIELD',
    defaultMessage: 'MANDATORY_FIELD'
  },
  CONSUMER_PLACEHOLDER: {
    id: 'consumer.CONSUMER_PLACEHOLDER',
    defaultMessage: 'CONSUMER_PLACEHOLDER'
  }
})



// WEBPACK FOOTER //
// ./src/constants/Consumer.js